import { render } from "./GlobalDialogHost.vue?vue&type=template&id=2544cd44&scoped=true"
import script from "./GlobalDialogHost.vue?vue&type=script&lang=js"
export * from "./GlobalDialogHost.vue?vue&type=script&lang=js"

import "./GlobalDialogHost.vue?vue&type=style&index=0&id=2544cd44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2544cd44"]])

export default __exports__